import { CloseIcon } from '@chakra-ui/icons';
import { useToken } from '@chakra-ui/react';
import { ClearIndicatorProps, components, GroupBase } from 'react-select';

import { DropdownOption } from '../../DropdownInput/typings';

const ClearIndicator = <
  Option = DropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: ClearIndicatorProps<Option, IsMulti, Group>,
) => {
  const [gray400] = useToken('colors', ['gray.400']);
  return (
    <components.ClearIndicator {...props}>
      <CloseIcon fontSize={12} color={gray400} marginRight='0.75rem' _hover={{ color: gray400, cursor: 'pointer' }} />
    </components.ClearIndicator>
  );
};

export default ClearIndicator;
